module.exports = __webpack_public_path__ + "media/images/homes/dashboard_analytics-b88087fe632faab01647124024ace6a8.svg";